module.exports = __webpack_public_path__ + "img/44.4692895d.jpg";